export default __webpack_public_path__ + "static/media/maintenance-bg.a9b83c72.png";